import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Loading } from '@match/react-component-library';
import { SearchResults } from 'modules/components';
import api from 'utils/api-services';
import { Topic } from 'types';

function useCleanUrlParam() {
  const query = useLocation().search;

  return decodeURIComponent(query)
    .split('?value=')
    .filter((elem: string) => elem !== '')[0];
}

function SearchResultsPage() {
  const searchString = useCleanUrlParam();

  const [answers, setAnswers] = useState<Topic[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    api
      .getTopicsByKeyword(searchString)
      .then((data) => {
        setAnswers(data as Topic[]);
        setLoading(false);
      })
      .catch((err: Error) => err);
  }, [searchString]);

  return (
    <React.Fragment>
      {loading ? (
        <Box alignItems="center" display="flex" flex={1} justifyContent="space-around" width="100%">
          <Loading />
        </Box>
      ) : (
        <SearchResults answers={answers} searchString={searchString} />
      )}
    </React.Fragment>
  );
}

export default React.memo(SearchResultsPage);
